import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { site } from "@/data/store";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-black/10 bg-[#F7F5F1]">
    <div className="mx-auto flex max-w-[1440px] flex-col gap-10 px-5 py-20 sm:px-8 md:flex-row md:items-end md:justify-between lg:px-12">
      <div>
        <p className="font-serif text-3xl tracking-[0.28em]">{site.brandName}</p>
        <p className="mt-3 max-w-xs text-sm text-black/60">{site.tagline}</p>
      </div>
      <div className="flex flex-col gap-4 md:items-end">
        <div className="flex items-center gap-6">
          <a href={`mailto:${site.contactEmail}`} data-testid="footer-email" className="nav-link text-sm">
            {site.contactEmail}
          </a>
          {site.instagramUrl && (
            <a href={site.instagramUrl} target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="footer-instagram" className="opacity-80 transition-opacity duration-300 hover:opacity-100">
              <Instagram className="h-5 w-5" strokeWidth={1.5} />
            </a>
          )}
        </div>
        <p data-testid="footer-copyright" className="text-xs uppercase tracking-[0.16em] text-black/50">
          © {new Date().getFullYear()} {site.brandName}. All rights reserved.
          <Link to="/refund-policy" data-testid="footer-refund-policy" className="nav-link ml-4 text-black/70">Refund Policy</Link>
        </p>
      </div>
    </div>
  </footer>
);
